
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.8 25l7-14.8c.3-.6.2-1.3-.1-1.9-.4-.6-1-.9-1.7-.9H2c-1.1 0-2 .9-2 2v31.2c0 1.1.9 2 2 2h46c.7 0 1.3-.3 1.7-.9.4-.6.4-1.3.1-1.9l-7-14.8zM3.9 38.7V11.3H45l-6.1 12.8c-.3.5-.3 1.1 0 1.7L45 38.7H3.9z","fill":"#fff"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M10 31.6V18.4h9V21h-6.1v2.7h5.3v2.6h-5.3v2.9H19v2.6h-9v-.2zM26.8 31.9c-1.2 0-2.2-.2-3-.6s-1.5-.9-2.1-1.6l1.9-1.9c.9 1 2 1.5 3.3 1.5.7 0 1.2-.1 1.6-.4.3-.3.5-.7.5-1.1s-.1-.7-.3-.9c-.2-.2-.6-.4-1.2-.5l-1.3-.2c-1.4-.2-2.4-.6-3.1-1.3-.7-.7-1-1.6-1-2.7 0-.6.1-1.1.3-1.6.2-.5.6-.9 1-1.3s.9-.6 1.6-.8c.6-.2 1.3-.3 2.1-.3 1 0 1.9.2 2.6.5.8.3 1.4.8 2 1.4L29.8 22c-.3-.4-.7-.7-1.1-.9-.4-.2-1-.3-1.7-.3-.6 0-1.1.1-1.4.3-.4.2-.6.5-.6.9 0 .5.1.8.4 1 .2.2.6.3 1.2.4l1.3.2c1.4.2 2.4.6 3 1.3.7.6 1 1.5 1 2.7 0 .6-.1 1.2-.3 1.7-.2.5-.6 1-1 1.4s-1 .7-1.6.9-1.4.3-2.2.3z"}})])])
          )
        }
      }
    